import { TableHead, SearchData } from "../../../../common/dataClass/Default"

/**搜索数据 */
class SalesSearchData extends SearchData{
  constructor() {
    super()
    /**店铺 */
    this.store = ''
    /**国家站点 */
    this.countrySite = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

/**商品销量表头 */
class SalesTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

class SalesNewModule{
  /**商品销量表头 */
  static NEWTABLEHEAD(){
    let arr = [
      new SalesTableHead('图片', 'img', '100'),
      new SalesTableHead('商品标题/ASIN/卖家SKU', 'name', '250'),
      new SalesTableHead('店铺名称', 'storeName', '150'),
      new SalesTableHead('国家站点', 'countrySiteName', '150'),
      new SalesTableHead('售价<br>(Your Price)', 'unitName', '100'),
      new SalesTableHead('近三期销量', 'stockPrice', '200'),
      new SalesTableHead('近三期销售额', 'getSavePriceByTable', '200'),
      new SalesTableHead('近三期增长率', 'getCostSummaryByTable', '200'),
      new SalesTableHead('FBA可售数量', 'getNetProfitOfGoodsByTable', '100'),
      new SalesTableHead('将入库数量', 'getCostOfCommodityInvestmentByTable', '100'),
      new SalesTableHead('预计可售天数', 'getCommodityCollectionByTable', '100'),
    ]
    return arr
  }
}

export { SalesSearchData, SalesNewModule }
